import { http } from '../plugins/http'
import { type AxiosResponse } from 'axios'

import { useProducerStore } from '@/stores/producer'
import type { Invoice } from '@/types/Invoice'
import type PaginatedResponse from '@/types/PaginatedResponse'

export default class InvoiceService {
  async index(
    page: number,
    filters: string,
    per_page: number | undefined = 10,
  ): Promise<AxiosResponse<PaginatedResponse<Invoice[]>>> {
    const producer_id = useProducerStore().producer?.id

    if (producer_id === undefined) throw new Error('Produtor não selecionado')

    return http.get<PaginatedResponse<Invoice[]>>(
      `/api/v1/office/orders/${producer_id}/invoices?page=${page}&${filters}&per_page=${per_page}`,
    )
  }

  async report(
    filters: string,
    selected: Record<string, string>,
  ): Promise<AxiosResponse<BlobPart>> {
    const producer_id = useProducerStore().producer?.id
    if (producer_id === undefined) throw new Error('Produtor não selecionado')

    filters = filters !== '' ? `?${filters}` : ''

    return await http.post(
      `/api/v1/office/orders/${producer_id}/invoices${filters}`,
      { selected },
      {
        headers: {
          Accept: 'application/csv',
        },
      },
    )
  }
}
